/**
 * Returns the time difference between two dates in hh:mm:ss format
 * @param date1 string
 * @param date2 string
 * @returns 00:00:00 format
 */
export const difference = (date1: string, date2: string) => {
  const endDate = new Date(date1).getTime();
  const startDate = new Date(date2).getTime();

  let seconds = Math.floor((endDate - startDate) / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  hours -= days * 24;
  minutes = minutes - days * 24 * 60 - hours * 60;
  seconds = seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

  return `${hours < 10 ? 0 : ''}${hours}:${minutes < 10 ? 0 : ''}${minutes}:${
    seconds < 10 ? 0 : ''
  }${seconds}`;
};
